import React from 'react';

import OfferingPackagePage from '../../../components/package/OfferingPackagePage';
import NotFoundPage from '../../../components/page/NotFoundPage';
import { type OfferingPackagePageOpportunityCoachFragment } from '../../package/__generated-gql-types__/OfferingPackagePage.generated';

import {
  PublishedOfferingPackagePageGetOfferingPackageBySlugDocument,
  type PublishedOfferingPackagePageOfferingPackageFragment,
} from './__generated-gql-types__/[packageSlug].generated';
interface PublishedOfferingPackagePageProps {
  offeringPackage: Possible<PublishedOfferingPackagePageOfferingPackageFragment>;
  coach?: Possible<OfferingPackagePageOpportunityCoachFragment>;
}

const PublishedOfferingPackagePage: React.FC<
  PublishedOfferingPackagePageProps
> = ({ offeringPackage, coach }) => {
  if (!offeringPackage) {
    return <NotFoundPage entity="package" />;
  }

  return (
    <OfferingPackagePage
      offeringPackage={offeringPackage}
      coachPackages={offeringPackage.coach.packages}
      coach={coach ?? undefined}
      refetchQueries={[
        PublishedOfferingPackagePageGetOfferingPackageBySlugDocument,
      ]}
    />
  );
};

export default PublishedOfferingPackagePage;
